{
  "messages": {
    "en": {
      "notifyDeleteUser": {
        "message": "You have requested to delete your account. Your account will be permanently deleted on {deletionDueDate}.",
        "caption": "You can revoke this action anytime through your Account settings page."
      },
      "ssoError": {
        "email_verification": "An email address is required to sign in. Please ensure your {driver} account has a verified email.",
        "deactivated": "This account has been deactivated. Please contact support for assistance.",
        "generic": "Something went wrong during sign in. Please try again."
      }
    },
    "el": {
      "notifyDeleteUser": {
        "message": "Πραγματοποιήσατε αίτημα διαγραφής λογαριασμού. Ο λογαριασμός σας θα διαγραφεί μόνιμα στις {deletionDueDate}.",
        "caption": "Μπορείτε να ακυρώσετε το αίτημα μέσα από τη σελίδα Ρυθμίσεις."
      },
      "ssoError": {
        "email_verification": "Απαιτείται διεύθυνση email για τη σύνδεση. Βεβαιωθείτε ότι ο λογαριασμός σας στο {driver} έχει επαληθευμένο email.",
        "deactivated": "Αυτός ο λογαριασμός έχει απενεργοποιηθεί. Επικοινωνήστε με την υποστήριξη για βοήθεια.",
        "generic": "Κάτι πήγε στραβά κατά τη σύνδεση. Παρακαλώ δοκιμάστε ξανά."
      }
    }
  }
}
